import { CardContainer } from "components/elements";
import EmployeeSalaryBonusTable from "components/table/EmployeeSalaryBonusTable";

function EmployeeSalaryBonus({
  bonusList = [],
  pagination = {},
  isLoading = false,
  onChange = () => { },
}) {
  return (
    <EmployeeSalaryBonusTable
      isLoading={isLoading}
      dataSource={bonusList}
      pagination={pagination}
      onChange={onChange}
    />
  );
}

export default EmployeeSalaryBonus;
